

import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import config from '@/config/config'
import cookie from "@utils/store/cookie";
import request from '@utils/request';
import toast from '@utils/toast'
import combo from '@utils/combo'
import comapi from '@utils/comapi'
import filters from '@/filters';

import {
isWeixin,
parseQuery,
} from "@utils";
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import DefaultImg from '@assets/default.png'
const VUE_APP_VERSION = require('../package.json').version
const vers = window.localStorage.getItem('appVersion')
if(VUE_APP_VERSION != vers){
localStorage.clear()
window.localStorage.setItem('appVersion', VUE_APP_VERSION)
location.reload()
}
Vue.prototype.$store = store
Vue.prototype.$http = request;
Vue.prototype.$post = request.post;




Vue.prototype.$toast = toast;
Vue.prototype.$combo = combo;
Vue.prototype.$comapi = comapi;
Vue.prototype.$config = config;


Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)

Vue.prototype.default_img = DefaultImg;
Vue.prototype.ImgError = function() {
let img = event.srcElement
img.src = DefaultImg
img.onerror = null
}

Vue.config.productionTip = false

let cookieName = "VCONSOLE";
let query = parseQuery();
let vconsole = query[cookieName.toLowerCase()];
let md5Crmeb = "1"; 
let md5UnCrmeb = "0"; 

if (vconsole !== undefined) {
if (vconsole === md5UnCrmeb && cookie.has(cookieName)) {
cookie.remove(cookieName);
}
} else {
vconsole = cookie.get(cookieName);
}
if (vconsole !== undefined && vconsole === md5Crmeb) {
cookie.set(cookieName, md5Crmeb, 3600);
new VConsole()





}









router.beforeEach((to, from, next) => {
/* 路由发生变化修改页面title */
if (to.meta.title) {
document.title = to.meta.title
}
next()
})
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));
/* eslint-disable no-new */
let that = new Vue({
el: '#app',
router,
components: {
App,
},
template: '<App/>',
})
export default that



// WEBPACK FOOTER //
// ./src/main.js